module.exports = __webpack_public_path__ + "img/102.français.011ac227.svg";